var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WarnTips',{attrs:{"show":true,"showVipText":!_vm.vip,"normalText":_vm.descriptionStr,"vipText":_vm.$t('tobuy'),"triggerStr":'recycleTimeFloat'}})}
var staticRenderFns = []

export { render, staticRenderFns }